import { enumeration } from '@dazn/peng-html5-tools-utils';
/**
 * A map of pin lifetime values.
 */
var PinLifetime = enumeration({
    NEVER: 0,
    SESSION: 1,
    PLAYER: 2,
});
export { PinLifetime };
//# sourceMappingURL=PinLifetime.js.map